/* eslint-disable import/prefer-default-export */
import Progress, { thunkProgress } from 'redux-progress';
import { CartThunk } from 'model/State';
import { goNext } from 'modules/checkout/duck/actions';
import * as steps from 'modules/checkout/steps';
import { actions as cartActions } from 'modules/cart';
import { getTaxExemptions } from 'modules/utils';
import getShowSubmitLoading from '../selectors/getShowSubmitLoading';

export const SUBMIT = 'checkout/contact/SUBMIT';
export const submit = (): CartThunk<Promise<Progress<any>> | null> => (dispatch, getState) => {
  const state = getState();

  const requestsInProgress = getShowSubmitLoading(state);
  if (requestsInProgress) {
    return Promise.resolve(Progress.success());
  }
  return state.checkout.contacts.data.ifSuccess((data) => {
    const setOrgDetails = (orgDetails) => {
      const taxExemptions = getTaxExemptions(
        orgDetails.isoCountryCode,
        orgDetails.taxId,
        orgDetails.state,
        orgDetails.taxExemptions,
      );

      return {
        ...orgDetails,
        taxExemptions,
      };
    };
    const payload = {
      ...state.cart.payload.result,
      ...data,
      billingContactDetails: data.isDifferentBilling
        ? data.billingContactDetails
        : data.purchaserContactDetails,
      technicalContactDetails: data.isDifferentTechnical
        ? data.technicalContactDetails
        : data.purchaserContactDetails,
      billingOrganisationDetails: setOrgDetails(data.billingOrganisationDetails),
      technicalOrganisationDetails: data.resellerOrder
        ? setOrgDetails(data.technicalOrganisationDetails)
        : setOrgDetails(data.billingOrganisationDetails),
    };

    return dispatch(
      thunkProgress(
        SUBMIT,
        (async () => {
          (await dispatch(cartActions.setCartDetails(payload))).unwrap();
          dispatch(steps.markComplete('contact'));
          dispatch(goNext());
        })(),
      ),
    );
  });
};
